import APIEndpoint from "./APIEndpoint";
import { AttributionData } from "../utils/attribution";

export const register = async (
  email: string,
  password: string,
  metaEventId?: string,
  attribution?: AttributionData
) => {
  const refId = localStorage.getItem("referringId");
  return fetch(APIEndpoint + "/users/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: email,
      password: password,
      refId,
      metaEventId,
      attribution,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.success === true) {
        localStorage.setItem("token", res.token);
        return res;
      } else {
        return res;
      }
    })
    .catch((e) => {
      console.log("API Call, error registering", e);
    });
};
